/* eslint-disable react/prop-types */
import React from 'react';
import { clsx as cx } from 'clsx';

export const NotificationList = ({ children, className, ...props }) => (
	<div className={cx('overflow-y-auto pb-6 px-notification-list', className)} {...props}>{children}</div>
);

export const NoNotificationsMsg = ({ children, className, ...props }) => (
	<div className={cx('p-4', className)} {...props}>{children}</div>
);

export const SpinnerContainer = ({ children, className, style, ...props }) => (
	<div className={cx('mb-6', className)} style={{ height: '4.5rem', ...style }} {...props}>{children}</div>
);

export const LoadMoreContainer = ({ children, className, ...props }) => (
	<div className={cx('mb-6 flex items-center justify-center p-4', className)} {...props}>{children}</div>
);
